module.exports = __webpack_public_path__ + "img/children.5de9ba1e.png";